import { render, staticRenderFns } from "./reviews-analytics.vue?vue&type=template&id=4f945405"
import script from "./reviews-analytics.vue?vue&type=script&lang=js"
export * from "./reviews-analytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports